import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { AbandonedBookingRecovery } from "../../components/AbandonedBookingRecovery/AbandonedBookingRecovery";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Page } from "../Page";

export const AbandonedBookingRecoveryPage = () => {
    return (
        <Page title="Abandoned Reservation Recovery">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Marketing</Breadcrumb.Item>
                        <Breadcrumb.Item>Abandoned Reservation Recovery</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <AbandonedBookingRecovery />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
